import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Configure14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25 2.875C6.25 2.20882 6.8112 1.75 7.4 1.75H10.6C11.1888 1.75 11.75 2.20882 11.75 2.875V3.25L14 3.25V4.75L11.75 4.75V5.125C11.75 5.79118 11.1888 6.25 10.6 6.25H7.4C6.8112 6.25 6.25 5.79118 6.25 5.125V4.75H0V3.25H6.25V2.875ZM7.75 3.25V4.75H10.25V3.25H7.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 9.25V8.875C2.25 8.20882 2.8112 7.75 3.4 7.75L6.6 7.75C7.1888 7.75 7.75 8.20882 7.75 8.875V9.25L14 9.25V10.75L7.75 10.75V11.125C7.75 11.7912 7.1888 12.25 6.6 12.25H3.4C2.8112 12.25 2.25 11.7912 2.25 11.125V10.75L0 10.75V9.25L2.25 9.25ZM6.25 9.25L6.25 10.75H3.75V9.25L6.25 9.25Z'
      fill='currentColor'
    />
  </Svg>
);

Configure14.displayName = 'Configure14';
export default Configure14;
